import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {BasicBitmapCountUp} from "../../components/BasicBitmapCountUp";
import {BenjiKIVGameAssets} from "../../BenjiKIVGameAssets";
import {BetWayWins} from "../../server/BenjiKIVData";
import {BenjiKIV} from "../../BenjiKIV";
import {gsap} from "gsap";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {Multiplier} from "../../components/Multiplier";
import {BenjiKIVSound} from "../../sound/BenjiKIVSound";

export class BenjiKIVMultiplierCountUpView extends PIXI.Container implements StageLayer {
    private _fxCupBelowContainer: PIXI.Container;
    private _fxCupAboveContainer: PIXI.Container;

    constructor() {
        super();
        this.name = "BenjiKIVMultiplierCountUpView";

        this.init();
    }

    private _multipliers: Multiplier[] = [];

    get multipliers(): Multiplier[] {
        return this._multipliers;
    }

    public setYPos(fromToggle: boolean, fromBigWin: boolean) {
        this.y = (fromToggle ? 320 : 250);

        if (fromBigWin) {
            this.y = 470;
            this._multipliers.forEach((value: Multiplier) => {
                value.defaultScale = 1.3;
            });
        } else if (!fromToggle) {
            this._multipliers.forEach((value: Multiplier) => {
                value.defaultScale = 1;
            });
        }
    }

    public onBigWinEnd(): void {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.to(this, {
            duration: 0.3,
            y: 380
        });
        tl.add(() => {
            this.playFSCupAnimation();
        });
    }

    public summariseMultiplierCountUp(): void {
        const betWayWins: BetWayWins[] = BenjiKIV.model.gameData.betWayWins;
        let idx: number = -1;

        for (let i: number = 0; i < betWayWins.length; i++) {
            if (betWayWins[i].multiplier > 1) {
                if (idx === -1) {
                    idx = i;
                    this.showMultipliers(betWayWins, idx);
                }
                this.setMultiplier(i, betWayWins[i].multiplier);
            }
        }
    }

    public show1Multiplier(idx:number):void {
        if(this._multipliers[idx]) {
            this._multipliers[idx].x = 360;
            this._multipliers[idx].scale.set(1);
            this._multipliers[idx].visible = true;
            this._multipliers[idx].setAmountTextScale();
        }
    }

    public setMultiplier(ctr: number, value: number): void {
        this._multipliers[ctr].visible = (value > 1);
        this._multipliers[ctr].forceSetText("x" + value);
    }

    // #202
    public playFSCupAnimation(): void {
        let fxCupBelow: TimelineSprite,
            fxCupAbove: TimelineSprite,
            soundPlayed: boolean = false;

        for (let i: number = 0; i < this._multipliers.length; i++) {
            if (this._multipliers[i].visible) {
                fxCupBelow = new TimelineSprite(BenjiKIV.assetLoader.getTextures("FX_CUP_Below/FX_CUP_Below_"));
                fxCupBelow.hide();
                fxCupBelow.anchor.set(0.5);
                fxCupBelow.blendMode = PIXI.BLEND_MODES.ADD;
                fxCupBelow.position = this._multipliers[i].position;
                fxCupBelow.getAnimationAutoShowHide(true, true, undefined, undefined, () => {
                    this._fxCupBelowContainer.removeChildren();
                });
                this._fxCupBelowContainer.addChild(fxCupBelow);

                fxCupAbove = new TimelineSprite(BenjiKIV.assetLoader.getTextures("FX_CUP_Above/FX_CUP_Above_"));
                fxCupAbove.hide();
                fxCupAbove.anchor.set(0.5);
                fxCupAbove.blendMode = PIXI.BLEND_MODES.ADD;
                fxCupAbove.position = this._multipliers[i].position;
                fxCupAbove.getAnimationAutoShowHide(true, true, undefined, undefined, () => {
                    this._fxCupAboveContainer.removeChildren();
                });
                this._fxCupAboveContainer.addChild(fxCupAbove);

                // #229
                if (!soundPlayed) {
                    BenjiKIV.soundPlayer.playSound(BenjiKIVSound.MULTIPLIER_BIG_WIN_END, 0.7);

                    soundPlayed = true;
                }
            }
        }
    }

    public hideAllMultipliers(): void {
        this._multipliers.forEach((multiplier: BasicBitmapCountUp) => {
            multiplier.visible = false;

            multiplier.forceSetText("x2");
            multiplier.scale.set(1);
        });

        this._fxCupBelowContainer.removeChildren();
        this._fxCupAboveContainer.removeChildren();
    }

    public show2Multipliers(idx: number): void {
        if (idx > 0) {
            this._multipliers[0].visible = false;
        }

        const xPos: number[] = [250, 470];
        for (let i: number = 0; i < xPos.length; i++) {
            this._multipliers[idx].x = xPos[i];
            this._multipliers[idx].scale.set(1);
            this._multipliers[idx].visible = true;
            idx++;

            if (i === 0) {
                this._multipliers[idx].setAmountTextScaleOnSummary();
            }
        }
    }

    public show3Multipliers(): void {
        const xPos: number[] = [180, 360, 540];
        for (let i: number = 0; i < xPos.length; i++) {
            this._multipliers[i].x = xPos[i];
            this._multipliers[i].scale.set(1);
            this._multipliers[i].visible = true;

            if (i !== 2) {
                this._multipliers[i].setAmountTextScaleOnSummary();
            }
        }
    }

    private showMultipliers(betWayWins: BetWayWins[], idx: number): void {
        let multiplierCount: number = 0;

        for (let i: number = 0; i < betWayWins.length; i++) {
            if (betWayWins[i].multiplier > 1) {
                multiplierCount++;
            }
        }

        if (multiplierCount === 1) {
            this.show1Multiplier(idx);
        } else if (multiplierCount === 2) {
            this.show2Multipliers(idx);
        } else if (multiplierCount === 3) {
            this.show3Multipliers();
        }
    }

    private init(): void {
        let multiplier: Multiplier;

        this._fxCupBelowContainer = new PIXI.Container();
        this.addChild(this._fxCupBelowContainer);

        for (let i: number = 0; i < 3; i++) {
            multiplier = new Multiplier({
                fontName: BenjiKIVGameAssets.BITMAP_FONT_COUNT_UP_MULTIPLIER,
                fontSize: 60,
                tint: 0xffffff
            }, 160, new PIXI.Point(0.5, 0.5));
            multiplier.visible = false;
            multiplier.forceSetText("x2");
            this._multipliers.push(multiplier);
            this.addChild(multiplier);
        }

        this._fxCupAboveContainer = new PIXI.Container();
        this.addChild(this._fxCupAboveContainer);
    }
}